<template>

    <div class="c-form_pain_body">
        <div @click="$emit('add-point', name, $event)" class="c-form_pain_body__body">
            <figure
                v-for="point in filteredPoints"
                :key="point.id"
                :style="cssPos(point)"
                class="c-form_pain_body__body-point">
                {{ point.id + 1 }}
            </figure>
            <img
                :src="require('Assets/images/' + image)"
                class="c-form_pain_body__body-img"
                :alt="caption">
        </div>
        <span class="c-form_pain_body__caption">{{ caption }}</span>
    </div>

</template>


<script>

export default {

    name: 'FormPainBody',

    props: {
        disabled: Boolean,
        caption: String,
        image: String,
        points: Array,
        name: String
    },

    computed: {
        filteredPoints() {
            return this.points.filter(({view}) => {
                return (view === this.name)
            })
        },
    },

    methods: {
        addPoint(view, e) {
            if (!this.disabled)
                this.$emit('add-point', view, e)
        },
        cssPos(point) {
            return {
                left: point.x_position + '%',
                top: point.y_position + '%'
            }
        }
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-form_pain_body {
    display: flex;
    flex-direction: column;
    width: 180px;
    height: 100%;

    &__body {
        position: relative;
        width: 100%;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;

        &-point {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            top: 0;
            left: 0;
            width: 1rem;
            height: 1rem;
            background-color: $c-primary;
            color: $c-white;
            font-size: 0.7rem;
            border-radius: 50%;
            box-shadow: 0 0 0 2.5px $c-white;
            transform: translate(-50%, -50%) scale(1);
            animation: point-add .2s cubic-bezier(.23, .11, .25, 1.66);
            pointer-events: none;
            cursor: context-menu;
            @keyframes point-add {
                0% {
                    transform: translate(-50%, -50%) scale(0);
                }
                100% {
                    transform: translate(-50%, -50%) scale(1);
                }
            }
        }
        &-img {
            width: 100%;
        }
    }
    &__caption {
        display: block;
        margin-top: 1.4rem;
        width: 100%;
        color: #D9D9DE;
        font-weight: 600;
        font-size: 0.9rem;
        text-align: center;
    }
}

</style>
